import { createContext, useContext } from "react";

import AppStore from "./AppStore";
import { IAppStore } from "./appStoreTypes";
import FeedStore from "./FeedStore";
import { IFeedStore } from "./feedStoreTypes";
import SearchStore from "./SearchStore";
import { ISearchStore } from "./searchStoreTypes";
import DetailStore from "./DetailStore";
import { IDetailStore } from "./detailStoreTypes";

export interface IContext {
  appStore: IAppStore;
  feedStore: IFeedStore;
  searchStore: ISearchStore;
  detailStore: IDetailStore;
}

export const store: IContext = {
  appStore: new AppStore(),
  feedStore: new FeedStore(),
  searchStore: new SearchStore(),
  detailStore: new DetailStore(),
};

export const StoreContext = createContext(store);
export const useStore = () => useContext(StoreContext);
